import React from 'react';

import {HStack, Text, VStack} from "@chakra-ui/react";

import {useLanguage} from "@/contexts/languageContext";

export const GuideTypeBody = ({element, ...props}) => {
    const {language} = useLanguage();

    return (
        <HStack gap="1vw" minH="3.5rem" color="secondary.500" overflow="hidden" {...props}>
            <VStack align="flex-start" justify="center" flex={1} overflow="hidden">
                <Text fontWeight="bold" fontSize="md" isTruncated>
                    {element?.[`${language}Title`] ?? element?.frTitle}
                </Text>
            </VStack>
            <Text fontSize="sm">#{element?.sortOrder ?? 0}</Text>
        </HStack>
    );
};

export default GuideTypeBody;
